<template>
    <div class="container-unit-maps">
        <section class="container-unit-fields">
            <div class="container-fields-integration">
                <ui-select-v2
                    v-model="fieldFacComputed"
                    :data="facilitaOptionsComputed"
					group-by="group"
                    return-value="object"
					item-label="label"
                    label="Campo Facilita:"
                    design="br-default"
                    size="sm"
                    type="text"
                    placeholder="Selecione um campo facilita"
                    required
                />
                <ui-select-v2
                    v-model="form.data.field_erp"
                    :data="erpOptions"
					group-by="group"
                    return-value="value"
                    label="Campo ERP:"
                    design="br-default"
                    size="sm"
                    placeholder="Selecione um campo de integração"
                    required
                />
            </div>

            <ui-select-v2
                v-model="form.data.regex"
                :data="regexOptions"
                return-value="label"
                label="Modelos:"
                design="br-default"
                size="sm"
                placeholder="Selecione um padrão regex"
                required
                @input="regexSelectHandler"
            />
        </section>

        <section class="container-regular-expression">
            <div v-if="isAdvanced" class="container-regular-expression-content">
                <ui-input
                    v-model="regexComputed"
                    label="Expressão RegExp:"
                    type="text"
                    placeholder="Digite..."
                />

                <ui-input-number
                    v-model="form.data.position"
                    required
					:min-value="0"
                    :max-value="1000"
                    label="Posição:"
                    size="md"
                />
            </div>
        </section>

        <div class="container-add-units-maps">
            <span :disabled="!canSubmit" class="add-units-maps" @click="add">
				<ui-load-indicator v-if="load" bg-color="#e7e9f4" color="#69D296" :h="20" :stroke="8"/>
				+ Adicionar campo mapeado
			</span>
        </div>

        <div class="hr" />

        <div class="container-table-row">
            <maps-units-table :contents="mappingsComputed" :loading="loading" />
        </div>
    </div>
</template>

<script>
	import { uiSelectV2, uiInput, uiInputNumber } from '@/components/ui/form'
	import mapsUnitsTable from './components/maps-units-table-row'
	import { uiLoadIndicator } from '@/components/ui'

	import { s3Filesystem, erp, product } from '@/services/axios'

	import { utilMixin } from '@/mixins'

	const lodash = require("lodash")

	const defaultFormData = (integration_erp_id, availability_id) => ({
		depara_type: 'units',
		integration_erp_id,
		availability_id,
		regex: null,
		label: null,
		field_fac: null,
		field_erp: null,
		pattern: '',
		regex_type: null,
		position: null
	})

	export default {
		name: 'ui-integrations-erp-unit-maps-fields',

		components: {
			uiSelectV2,
			uiInput,
			uiInputNumber,
			mapsUnitsTable,
			uiLoadIndicator
		},

		mixins: [utilMixin],

		props: {
			/**
			 * ID da disponibilidade
			 */
			id: {
				type: [Number,String],
				required: true,
				default: 0,
			},
			/**
			 * Tipo da disponibilidade
			 */
			type: {
				type: String,
				required: true,
			},
			/**
			 * Integração selecionada
			 */
			integration: {
				type: Object,
				required: true
			},
			/**
			 * Dados do empreendimento integrado que veio do ERP
			 */
			integrationProvider: {
				type: Object,
				required: true
			},
			/**
			 * Dados referentes aos mapeamentos
			 */
			data: {
				type: Array,
				required: true
			},
			/**
			 * Define o status do loading da tabela
			 */
			loading: {
				type: Boolean,
				required: false,
				default: true
			}
		},

		data(){
			return {
				form: {
					data: { ...defaultFormData(this.integration.id, this.id) },
					fields: {
						depara_type: {
							required: true,
							disabled: false
						},
						integration_erp_id: {
							required: true,
							disabled: false
						},
						availability_id: {
							required: true,
							disabled: false
						},
						label: {
							required: true,
							disabled: false
						},
						field_fac: {
							required: true,
							disabled: false
						},
						field_erp: {
							required: true,
							disabled: false
						},
						pattern: {
							required: true,
							disabled: false
						},
						regex_type: {
							required: true,
							disabled: false
						},
						position: {
							required: true,
							disabled: false
						}
					}
				},
				facilitaOptions: [],
				erpOptions: [],
				regexOptions: [],
				isAdvanced: false,
				load: false
			}
		},

		computed: {
			/**
			 * Computed property que formata os mapeamentos antes de listá-los
			 */
			mappingsComputed() {
				const mapped = Object.values(this.data).map(item => {
					const field = this.erpOptions.find(option => option.value === item.field_erp)
					item.label_erp = field ? field.label : 'Não encontrado'

					return item
				})

				return this.erpOptions.length ? mapped : []
			},
			/**
			 * Computed property que formata e filtra as opções de campos facilita
			 */
			facilitaOptionsComputed() {
				const fields = this.data.map(item => item.field_fac)
				return this.facilitaOptions.filter(field => !fields.includes(field.value))
			},
			/**
			 * Computed property que controla as seleções do campo facilita
			 */
			fieldFacComputed: {
				get() {
					return this.form.data.field_fac
						? { label: this.form.data.label, value: this.form.data.field_fac }
						: null
				},
				set(value) {
					this.form.data.field_fac = value.value
					this.form.data.label = value.label
				}
			},
			/**
			 * Computed property que formata os padrões Regex definidos no input
			 */
			regexComputed: {
				get() {
					return window.atob(this.form.data.pattern)
				},
				set(value) {
					this.form.data.pattern = window.btoa(value)
				}
			},
			/**
			 * Computed property que define se o formulário pode ser submetido
			 */
			canSubmit() {
				return this.validateForm().valid
			}
		},

		created() {
			this.$root.$on('modal-msg-delete-erp-units-mapping-response', (payload) => {
				this.$toastr.s(payload.msg)
				this.$emit('reload')
			})
		},

		mounted() {
			this.loadForm()
		},

		beforeDestroy() {
			this.$root.$off('modal-msg-delete-erp-units-mapping-response')
		},

		methods: {
			/**
			 * Carrega os dados necessários para montar o formulário
			 */
			loadForm: async function () {
				try {
					if (!(this.integrationProvider?.id && this.type)) {
						this.$toastr.e('Os dados do produto integrado/provider estão incompletos!')
						return
					}

					// Decodifica os dados de identificação do empreendimento ERP integrado
					const providerData = this.integrationProvider.id.split('.')
					const params = {
						id: providerData[0],
						emp: providerData[1],
						integration_id: this.integration?.id,
						type: this.type
					}

					// Busca os campos customizados do empreendimento em questão
					let response = await product.getAllV2('custom/fields', params)

					this.erpOptions = [
						...this.erpOptions,
						...Object.values(response.data?.data?.fieldsERP || []).map(field => {
							const {Campo, Descricao} = field
							return {
								group: 'Campos Padrões - ERP',
								label: Descricao,
								value: Campo
							}
						}),
						...Object.values(response.data?.data?.customFieldsERP || []).map(field => {
							const {Campo, Descricao} = field
							return {
								group: 'Campos Personalizados - ERP',
								label: Descricao,
								value: Campo
							}
						})
					]
					this.facilitaOptions = [
						...Object.values(response.data?.data?.fieldsFac || []).map((field) => {
							const {Campo, Descricao} = field
							if(Campo === 'block' || Campo === 'id' || Campo === 'pos_y' || Campo === 'pos_x' || Campo === 'number' || Campo === 'cost') {
								return {
									...field, 
									group: 'Campos Padrões - Facilita',
									label: Descricao,
									value: Campo,
									required: true
								}
							}
							return {
								group: 'Campos Padrões - Facilita',
								label: Descricao,
								value: Campo
							}
						}),
						...Object.values(response.data?.data?.customFieldsFac || []).map((field) => {
							const {Campo, Descricao} = field
							return {
								group: 'Campos Personalizados - Facilita',
								label: Descricao,
								value: Campo
							}
						})
					]

					response = await s3Filesystem.getUnitExibitionModels()
					/**
					 * Passa todos os identificadores dos regex para minúsculo de modo
					 * a possibilitar à seleção correta de acordo com os campos selecionados
					 */
					this.regexOptions = Object.values(response.data).map(item => {
						return Object.keys(item).reduce((accumulator, key) => {
							accumulator[key.toLowerCase()] = item[key]

							return accumulator
						}, {})
					})

				} catch (error) {
					if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
					console.log(error)
				}
			},
			/**
			 * Trata o evento de quando um padrão Regex é selecionado
			 */
			regexSelectHandler(value) {
				const regex = this.regexOptions.find(item => item.label === value)
				if (!regex) return

				this.isAdvanced = window.atob(regex.value) === 'regexp'
				if (!this.isAdvanced) {
					this.form.data.pattern = regex.value
					let position = regex.positionnumber
					if (['block', 'number', 'floor', 'pos_y', 'pos_x'].includes(this.form.data.field_fac)) {
						position = regex[`position${this.form.data.field_fac}`]
					}
					this.form.data.position = Number.parseInt(position)
				}
				this.form.data.regex_type = regex.typeregexp
			},
			/**
			 * Valida a propriedade required dos campos do formulário
			 */
			validateRequired(field, dataField = '') {
				if (!Object.prototype.hasOwnProperty.call(this.form.fields, field)) {
					throw new Error(`Falha ao validar o campo ${field}. Este campo não existe!`)
				}
				dataField = dataField || field
				const required = this.form.fields[field].required
				const validation = this.$mx_hasValue(lodash.get(this.form.data, dataField))

				return (required && validation) || !required
			},
			/**
			 * Valida os campos do formulário de acordo com diferentes conjuntos de regras
			 */
			validateForm() {
				let valid = true
				let message = '<ul>'
				try {
					if (!this.validateRequired('depara_type')) {
						valid = false
						message += '<li>É necessário definir o tipo de mapeamento.</li>'
					}

					if (!this.validateRequired('integration_erp_id')) {
						valid = false
						message += '<li>É necessário selecionar uma integração.</li>'
					}

					if (!this.validateRequired('availability_id')) {
						valid = false
						message += '<li>É necessário selecionar uma disponibilidade.</li>'
					}

					if (!this.validateRequired('label')) {
						valid = false
						message += '<li>É necessário definir o label do campo mapeado.</li>'
					}

					if (!this.validateRequired('field_fac')) {
						valid = false
						message += '<li>É necessário selecionar um campo Facilita.</li>'
					}

					if (!this.validateRequired('field_erp')) {
						valid = false
						message += '<li>É necessário selecionar um campo ERP.</li>'
					}

					if (!this.validateRequired('pattern')) {
						valid = false
						message += '<li>É necessário definir o padrão Regex.</li>'
					}

					if (!this.validateRequired('regex_type')) {
						valid = false
						message += '<li>É necessário definir o tipo do padrão Regex.</li>'
					}

					if (!this.validateRequired('position')) {
						valid = false
						message += '<li>É necessário definir a posição do mapeamento.</li>'
					}

				} catch (e) {
					this.$toastr.e(e)
					valid = false
				}
				message += '</ul>'

				return { valid, message }
			},
			/**
			 * Adiciona um mapeamento de campo
			 */
			add() {
				this.load = true
				erp.createV2('fields-mapping', this.form.data)
					.then(response => {
						this.$toastr.s(response.data.msg)
						this.form.data = { ...defaultFormData(this.integration.id, this.id) }
						this.isAdvanced = false
						this.$emit('reload')
					})
					.catch(error => {
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
						console.log(error)
					})
					.finally(() => {
						this.load = false
					})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>